export const IsTrueBinary = (val: number): boolean => {
  return val === 1;
};

export const IsTrue = (val: string | boolean = false): boolean => {
  if (!val) {
    return false;
  }

  val = val.toString();
  return /^true$/i.test(val) || /^y$/i.test(val) || /^success$/i.test(val);
};
